import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tile-grid" }
const _hoisted_3 = {
  key: 1,
  class: "tile-grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pipeline_tile = _resolveComponent("pipeline-tile")!

  return (_ctx.group_by_namespaces || _ctx.group_by_groups)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            key: group.group_or_namespace
          }, [
            _createElementVNode("p", null, _toDisplayString(group.group_or_namespace), 1),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.pipelines, (pipeline) => {
                return (_openBlock(), _createBlock(_component_pipeline_tile, {
                  class: "tile",
                  key: pipeline.details.id,
                  pipeline: pipeline,
                  name: pipeline.projectName,
                  show_namespace: false,
                  show_namespace_ommitted_group: _ctx.group_by_groups,
                  show_branches: _ctx.show_branches,
                  show_history: _ctx.show_history
                }, null, 8, ["pipeline", "name", "show_namespace_ommitted_group", "show_branches", "show_history"]))
              }), 128))
            ])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pipelines, (pipeline) => {
          return (_openBlock(), _createBlock(_component_pipeline_tile, {
            class: "tile",
            key: pipeline.details.id,
            pipeline: pipeline,
            name: pipeline.projectName,
            show_namespace: true,
            show_branches: _ctx.show_branches,
            show_history: _ctx.show_history
          }, null, 8, ["pipeline", "name", "show_branches", "show_history"]))
        }), 128))
      ]))
}